<success-screen class="bp-modal mod-lg">
	<bp-modal-header header class="large-weight" [title]="'deposit' | translate">
		<a right (click)="done()" href="javascript:;" (keydown.enter)="done()" [tabIndex]="0">
			{{ "close" | translate }}
		</a>
	</bp-modal-header>
	<div content class="success-content-inner bp-modal-body">
		<div class="mt-100 mb-40">
			<span class="deposit-dot"></span>
			<span class="deposit-dot"></span>
			<span class="deposit-dot"></span>
		</div>
		<div class="success-headline mb-15">
			{{ "transaction_pending_information_header" | translate: [paymentOption?.getName()] }}
		</div>
		<p class="text-center mb-30">{{ "transaction_pending_information_header_addition" | translate }}</p>
		<div class="mb-60 text-center">
			<button class="btn btn-primary btn-lg btn-custom-padding" (click)="cancelTimer()">
				<div>
					<span class="large-weight">{{ "goto-payment" | translate }}</span>
					<img
						class="ml-20"
						[src]="'/assets/images/link-new-window-outline.svg'"
						[alt]="'open_in_new_tab_alt_Text' | translate" />
				</div>
			</button>
		</div>
		<div class="mb-40 text-center">
			<div class="large-weight">{{ "transaction_pending_information_nothing_happening" | translate }}</div>
			<div class="text-light">{{ "transaction_pending_information_nothing_addition" | translate }}</div>
		</div>
	</div>
</success-screen>
